module.exports = __webpack_public_path__ + "static/img/24.05246cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/24.jpg
// module id = OTyt
// module chunks = 0